"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _gerenciatdFormskeleton = _interopRequireDefault(require("@bit/gerenciatd.formskeleton.input"));

var _gerenciatdFormskeleton2 = _interopRequireDefault(require("@bit/gerenciatd.formskeleton.select"));

var _gerenciatdUnifiedcomponents = _interopRequireDefault(require("@bit/gerenciatd.unifiedcomponents.custom-link"));

var _gerenciatdUnifiedicons = _interopRequireWildcard(require("@bit/gerenciatd.unifiedicons.svg-icon-loader"));

var _gerenciatdUnifiedcomponents2 = _interopRequireWildcard(require("@bit/gerenciatd.unifiedcomponents.button"));

var _gerenciatdUtils = _interopRequireDefault(require("@bit/gerenciatd.utils.front-sonda"));

var _gerenciatdUtils2 = require("@bit/gerenciatd.utils.js-utils");

var _gerenciatdUnifiedcomponents3 = _interopRequireWildcard(require("@bit/gerenciatd.unifiedcomponents.text-info"));

var _gerenciatdUtils3 = require("@bit/gerenciatd.utils.metrics");

var _provincias = _interopRequireDefault(require("./provincias.json"));

var _functionsUtils = require("./functionsUtils.js");

require("./C2CEmpresas.scss");

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const {
  IDENTIFICATION_DOCUMENT_TYPES,
  validatorList
} = _gerenciatdUtils2.validators;
const ENCAMINAMIENTO_FONDOS = [_functionsUtils.TIPOS_ENCAMINAMIENTO.FONINS_A, _functionsUtils.TIPOS_ENCAMINAMIENTO.FONINS_B, _functionsUtils.TIPOS_ENCAMINAMIENTO.FONINS_C, _functionsUtils.TIPOS_ENCAMINAMIENTO.FONINS_D, _functionsUtils.TIPOS_ENCAMINAMIENTO.FONINS_E, _functionsUtils.TIPOS_ENCAMINAMIENTO.FONGEV_A, _functionsUtils.TIPOS_ENCAMINAMIENTO.FONGEV_B, _functionsUtils.TIPOS_ENCAMINAMIENTO.FONGEV_C, _functionsUtils.TIPOS_ENCAMINAMIENTO.FONGEV_D, _functionsUtils.TIPOS_ENCAMINAMIENTO.FONGEV_E];
const COMPONENT_NAME = 'C2CEmpresas';
/**
 * Variable con el context para la sonda
 */

const contextEmp = (0, _functionsUtils._createSondaContext)('empresas');

function usePrevious(value, validateForm) {
  const ref = (0, _react.useRef)();
  (0, _react.useEffect)(() => {
    if (validateForm) {
      ref.current = value;
    }
  }, [value, validateForm]);
  return ref.current;
}

const C2CEmpresas = _ref => {
  let {
    formSkeletonProps,
    Modal,
    taggingInfo,
    tipoTes,
    destino,
    tes,
    fixedCampaign,
    fixedProduct
  } = _ref;
  const {
    submitTries,
    validateForm
  } = formSkeletonProps;
  const prevSubmitTries = usePrevious(submitTries, validateForm);
  const [PrivacyPolicy, setPrivacyPolicy] = (0, _react.useState)(false);
  const [ModalState, setModalState] = (0, _react.useState)('c2c');
  const [datos, setDatos] = (0, _react.useState)({
    name: '',
    phone: '',
    cif: '',
    date: 'N/A',
    time: 'N/A',
    provincia: '',
    empleados: 'N/A'
  });

  if (!taggingInfo.componentName) {
    taggingInfo.componentName = COMPONENT_NAME;
  }
  /**
   * Handler de los inputs que guarda el valor en la variable de datos
   * @param {*} event Información que llega desde el onchange
   * @returns {undefined}
   */


  const handleInputChange = event => {
    setDatos(_objectSpread(_objectSpread({}, datos), {}, {
      [event.target.name]: event.target.value
    }));
  };
  /**
   * Handler del select time que guarda el valor en la variable de datos
   * @param {*} value Información que llega desde el onchange
   * @returns {undefined}
   */


  const handleSelectChangeTime = value => {
    setDatos(_objectSpread(_objectSpread({}, datos), {}, {
      time: value
    }));
  };
  /**
   * Handler del select date que guarda el valor en la variable de datos
   * @param {*} value Información que llega desde el onchange
   * @returns {undefined}
   */


  const handleSelectChangeDate = value => {
    setDatos(_objectSpread(_objectSpread({}, datos), {}, {
      date: value
    }));
  };
  /**
   * Handler del select date que guarda el valor en la variable de datos
   * @param {*} value Información que llega desde el onchange
   * @returns {undefined}
   */


  const handleSelectChangeProv = value => {
    setDatos(_objectSpread(_objectSpread({}, datos), {}, {
      provincia: value
    }));
  };

  const handleSelectChangeEmpleados = value => {
    setDatos(_objectSpread(_objectSpread({}, datos), {}, {
      empleados: value
    }));
  };
  /**
   * Metodo que gestiona el pintado de modales una vez que la info es enviadas
   * @returns {undefined}
   */


  const _infoSended = () => {
    setTimeout(() => {
      if ((0, _functionsUtils._CMNTimeTableValid)()) {
        setModalState(_functionsUtils.MODALS_TYPES.CALLPENDING);
      } else {
        setModalState(_functionsUtils.MODALS_TYPES.CMLPENDING);
      }
    }, 8000);
  };
  /**
   * Recoge los datos del formulario y los envia a BI y SE
   * @returns {undefined}
   */


  const _recogeDatosForm = (destinoValue, tipoTesValue, tesValue) => {
    try {
      setModalState(_functionsUtils.MODALS_TYPES.REQUESTPENDING);
      let destinoForm = '';

      switch (destinoValue) {
        case _functionsUtils.DESTINO.AVATAR:
          destinoForm = _functionsUtils.DESTINO_FORM.AVATAR;
          break;

        case _functionsUtils.DESTINO.FONDOS:
          destinoForm = _functionsUtils.DESTINO_FORM.FONDOS;
          break;

        case _functionsUtils.DESTINO.INSIDESALES:
          destinoForm = _functionsUtils.DESTINO_FORM.INSIDESALES;
          break;

        case _functionsUtils.DESTINO.GEVICO:
        default:
          destinoForm = _functionsUtils.DESTINO_FORM.GEVICO;
          break;
      }

      setTimeout(() => {
        (0, _functionsUtils._envioBI)(datos, destinoForm, contextEmp, fixedCampaign);
        const seOk = (0, _functionsUtils._envioSE)(datos, destinoForm, tipoTesValue, tesValue, contextEmp, fixedCampaign, fixedProduct);

        if (seOk) {
          _infoSended();

          const taggingInfoEvent = {
            event: 'cms-component',
            eventType: 'form',
            componentName: taggingInfo.componentName,
            componentVariation: destinoValue,
            componentContent: 'formulario-enviado',
            componentProduct: taggingInfo.componentProduct || ''
          };
          (0, _gerenciatdUtils3.sendCMSEvent)(taggingInfoEvent);
        } else {
          const sonda = new _gerenciatdUtils.default({
            processName: 'recogeDatosForm',
            context: contextEmp,
            filePath: 'emp/c2c'
          });
          const taggingInfoEvent = {
            event: 'cms-component',
            eventType: 'form',
            componentName: taggingInfo.componentName,
            componentVariation: destinoValue,
            componentContent: 'formulario-ko',
            componentProduct: taggingInfo.componentProduct || ''
          };
          (0, _gerenciatdUtils3.sendCMSEvent)(taggingInfoEvent);
          console.log(taggingInfoEvent);
          setModalState(_functionsUtils.MODALS_TYPES.CALLNOTSTABLISHED);
          sonda.severalMessage({
            info: 'Formulario SE no envio la información'
          });
        }
      }, 2000);
    } catch (error) {
      const sonda = new _gerenciatdUtils.default({
        processName: 'recogeDatosForm',
        context: contextEmp,
        filePath: 'emp/c2c'
      });
      const taggingInfoEvent = {
        event: 'cms-component',
        eventType: 'form',
        componentName: taggingInfo.componentName,
        componentVariation: destinoValue,
        componentContent: 'formulario-ko',
        componentProduct: taggingInfo.componentProduct || ''
      };
      (0, _gerenciatdUtils3.sendCMSEvent)(taggingInfoEvent);
      setModalState(_functionsUtils.MODALS_TYPES.CALLNOTSTABLISHED);
      sonda.severalMessage({
        error,
        info: 'Formulario no existe'
      });
    }
  };
  /**
   * Cambia entre visualizacion y ocultacion de politica de privacidad
   */


  const _togglePrivacyPolicy = () => {
    setPrivacyPolicy(!PrivacyPolicy);
  };

  const printHeadModal = () => {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("header", {
      className: "modal__header-emp",
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: "modal__header-padding",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
          src: "https://www.movistar.es/estaticos/imagenes/iconos/telefonica-empresas.png",
          alt: "Telefonica",
          className: "logo-img"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents.default, {
          taggingInfo: _objectSpread(_objectSpread({}, taggingInfo), {}, {
            componentContent: 'cerrar'
          }),
          onClick: Modal.hide,
          className: "closeButton",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedicons.default, {
            id: "Cerrar",
            color: "black",
            kind: _gerenciatdUnifiedicons.SVG_ICON_KIND.MEDIUM,
            size: 16
          })
        })]
      })
    });
  };

  const buttonPropsSize = {
    w: _gerenciatdUnifiedcomponents2.BUTTON_WIDTH.LARGE,
    h: _gerenciatdUnifiedcomponents2.BUTTON_HEIGHT.REGULAR
  };
  /**
   * Se activa cuando el formulario es validado, o se ha intentando subir el formulario
   */

  (0, _react.useEffect)(() => {
    if (validateForm && prevSubmitTries !== submitTries && submitTries > 0) {
      _recogeDatosForm(destino, tipoTes, tes);
    }
  }, [validateForm, prevSubmitTries, submitTries]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "C2CForm",
    children: [(0, _functionsUtils.printIframes)(), printHeadModal(), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "modal_wrapper-h2",
      children: _functionsUtils.MODAL_CONTENT[ModalState].title_emp && /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents3.default, {
        text: _functionsUtils.MODAL_CONTENT[ModalState].title_emp,
        align: _gerenciatdUnifiedcomponents3.ALIGN.CENTER,
        size: _gerenciatdUnifiedcomponents3.SIZE.TITLE3,
        color: _gerenciatdUnifiedcomponents3.COLOR.BLUE_DARK,
        fontType: _gerenciatdUnifiedcomponents3.FONT_TYPE.BOLD,
        kind: _gerenciatdUnifiedcomponents3.KIND_TEXT.HEADING,
        level: _gerenciatdUnifiedcomponents3.HEADING_LEVEL.H2,
        segment: _gerenciatdUnifiedcomponents3.SEGMENT.EMP
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "modal_wrapper-span",
      children: _functionsUtils.MODAL_CONTENT[ModalState].content_emp && /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents3.default, {
        text: _functionsUtils.MODAL_CONTENT[ModalState].content_emp,
        align: _gerenciatdUnifiedcomponents3.ALIGN.CENTER,
        size: _gerenciatdUnifiedcomponents3.SIZE.CAPTION1,
        color: _gerenciatdUnifiedcomponents3.COLOR.GREY_4,
        fontType: _gerenciatdUnifiedcomponents3.FONT_TYPE.REGULAR,
        kind: _gerenciatdUnifiedcomponents3.KIND_TEXT.SPAN,
        segment: _gerenciatdUnifiedcomponents3.SEGMENT.EMP,
        display: _gerenciatdUnifiedcomponents3.DISPLAY.BLOCK
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "modal_wrapper-span",
      children: _functionsUtils.MODAL_CONTENT[ModalState].horario_emp && /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents3.default, {
        text: _functionsUtils.MODAL_CONTENT[ModalState].horario_emp,
        align: _gerenciatdUnifiedcomponents3.ALIGN.CENTER,
        size: _gerenciatdUnifiedcomponents3.SIZE.CAPTION1,
        color: _gerenciatdUnifiedcomponents3.COLOR.DARK,
        fontType: _gerenciatdUnifiedcomponents3.FONT_TYPE.REGULAR,
        kind: _gerenciatdUnifiedcomponents3.KIND_TEXT.SPAN,
        segment: _gerenciatdUnifiedcomponents3.SEGMENT.EMP,
        display: _gerenciatdUnifiedcomponents3.DISPLAY.BLOCK
      })
    }), ModalState === _functionsUtils.MODALS_TYPES.C2C && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.Fragment, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: "modal_formInputs",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdFormskeleton.default, {
          id: "name",
          name: "name",
          typeField: "text",
          theme: "line",
          onChange: handleInputChange,
          placeHolder: "Nombre",
          taggingInfo: _objectSpread(_objectSpread({}, taggingInfo), {}, {
            componentContent: 'input-name'
          }),
          required: true,
          formSkeletonProps: formSkeletonProps
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdFormskeleton.default, {
          id: "phone",
          name: "phone",
          typeField: "tel",
          theme: "line",
          onChange: handleInputChange,
          placeHolder: "Telefono",
          taggingInfo: _objectSpread(_objectSpread({}, taggingInfo), {}, {
            componentContent: 'input-phone'
          }),
          validators: [validatorList.ANY_PHONE],
          required: true,
          formSkeletonProps: formSkeletonProps
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdFormskeleton.default, {
          id: "cif",
          name: "cif",
          typeField: "text",
          theme: "line",
          onChange: handleInputChange,
          placeHolder: "CIF",
          validators: [validatorList.DOC_NUMBER],
          allowDocTypes: [IDENTIFICATION_DOCUMENT_TYPES.CIF],
          taggingInfo: _objectSpread(_objectSpread({}, taggingInfo), {}, {
            componentContent: 'input-cif'
          }),
          required: true,
          formSkeletonProps: formSkeletonProps
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdFormskeleton2.default, {
          title: "Provincia",
          name: "provincia",
          options: _provincias.default,
          onChange: handleSelectChangeProv,
          placeholder: "Provincia",
          required: true,
          formSkeletonProps: formSkeletonProps,
          taggingInfo: _objectSpread(_objectSpread({}, taggingInfo), {}, {
            componentContent: 'select-provincia'
          })
        }), (destino === _functionsUtils.DESTINO.FONDOS || ENCAMINAMIENTO_FONDOS.includes(tipoTes)) && /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdFormskeleton2.default, {
          name: "empleados",
          options: _functionsUtils.EMPLEADOS,
          onChange: handleSelectChangeEmpleados,
          placeholder: "Numero empleados",
          required: true,
          formSkeletonProps: formSkeletonProps,
          taggingInfo: _objectSpread(_objectSpread({}, taggingInfo), {}, {
            componentContent: 'select-empleados'
          })
        }), !(0, _functionsUtils._CMNTimeTableValid)() && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.Fragment, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdFormskeleton2.default, {
            title: "Selecciona uno",
            name: "date",
            options: [{
              label: 'Hoy',
              value: 'Hoy'
            }, {
              label: 'Mañana',
              value: 'Mañana'
            }, {
              label: 'Pasado Mañana',
              value: 'Pasado Mañana'
            }],
            onChange: handleSelectChangeDate,
            placeholder: "Dia",
            required: true,
            formSkeletonProps: formSkeletonProps,
            taggingInfo: _objectSpread(_objectSpread({}, taggingInfo), {}, {
              componentContent: 'select-date'
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdFormskeleton2.default, {
            title: "Selecciona uno",
            name: "time",
            options: [{
              label: '09:00 a 12:00',
              value: '09:00 a 12:00'
            }, {
              label: '12:00 a 16:00',
              value: '12:00 a 16:00'
            }, {
              label: '16:00 a 19:00',
              value: '16:00 a 19:00'
            }],
            onChange: handleSelectChangeTime,
            placeholder: "Hora",
            required: true,
            formSkeletonProps: formSkeletonProps,
            taggingInfo: _objectSpread(_objectSpread({}, taggingInfo), {}, {
              componentContent: 'select-time'
            })
          })]
        }), (0, _functionsUtils.printCheckBoxs)(taggingInfo)]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "modal_wrapper-legal",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents.default, {
          onClick: () => _togglePrivacyPolicy(false),
          taggingInfo: _objectSpread(_objectSpread({}, taggingInfo), {}, {
            componentContent: 'togglePrivacity'
          }),
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents3.default, {
            text: "Consulta aqu\xED la informaci\xF3n sobre privacidad",
            align: _gerenciatdUnifiedcomponents3.ALIGN.LEFT,
            size: _gerenciatdUnifiedcomponents3.SIZE.CAPTION2,
            color: _gerenciatdUnifiedcomponents3.COLOR.BLUE_MEDIUM,
            fontType: _gerenciatdUnifiedcomponents3.FONT_TYPE.REGULAR,
            kind: _gerenciatdUnifiedcomponents3.KIND_TEXT.SPAN,
            segment: _gerenciatdUnifiedcomponents3.SEGMENT.EMP,
            display: _gerenciatdUnifiedcomponents3.DISPLAY.BLOCK
          })
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "modal_wrapper-button",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents2.default, {
          className: "modal__button2 emp",
          taggingInfo: _objectSpread(_objectSpread({}, taggingInfo), {}, {
            componentContent: 'Te llamamos gratis'
          }),
          color: _gerenciatdUnifiedcomponents2.BUTTON_COLOR.BLUE_DARK,
          size: buttonPropsSize,
          labelSize: _gerenciatdUnifiedcomponents2.LABEL_SIZE.REGULAR,
          buttonType: "submit",
          label: /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents3.default, {
            text: "TE LLAMAMOS GRATIS",
            align: _gerenciatdUnifiedcomponents3.ALIGN.LEFT,
            size: _gerenciatdUnifiedcomponents3.SIZE.TITLE6,
            color: _gerenciatdUnifiedcomponents3.COLOR.WHITE,
            fontType: _gerenciatdUnifiedcomponents3.FONT_TYPE.REGULAR,
            kind: _gerenciatdUnifiedcomponents3.KIND_TEXT.SPAN,
            segment: _gerenciatdUnifiedcomponents3.SEGMENT.EMP,
            display: _gerenciatdUnifiedcomponents3.DISPLAY.INLINE
          }),
          segment: _gerenciatdUnifiedcomponents3.SEGMENT.GP
        })
      }), PrivacyPolicy && (0, _functionsUtils.printPrivacyPolicy)()]
    })]
  });
};

C2CEmpresas.propTypes = {
  Modal: _propTypes.default.func.isRequired,
  taggingInfo: _propTypes.default.arrayOf([_propTypes.default.string]).isRequired,
  tipoTes: _propTypes.default.oneOf([_functionsUtils.TIPOS_ENCAMINAMIENTO]).isRequired,
  destino: _propTypes.default.oneOf([_functionsUtils.DESTINO]).isRequired,
  tes: _propTypes.default.oneOf([_functionsUtils.TESVALUES]).isRequired,
  fixedCampaign: _propTypes.default.string,
  fixedProduct: _propTypes.default.string
};
C2CEmpresas.defaultProps = {
  tipoTes: _functionsUtils.TIPOS_ENCAMINAMIENTO.SVC_C,
  destino: _functionsUtils.DESTINO.GEVICO,
  tes: _functionsUtils.TESVALUES.SI,
  fixedCampaign: '',
  fixedProduct: ''
};
var _default = C2CEmpresas;
exports.default = _default;

//# sourceMappingURL=index.js.map